// assets
import eTrackIcon from '../assets/images/icons/global.svg';
// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //
const eTrack = {
  id: 'etrack',
  type: 'group',
  children: [
    {
      id: 'etrack',
      title: 'eTrack',
      type: 'collapse',
      icon: eTrackIcon,
      url: '/etrack',
      children: [
        {
          id: 'existing-quotes',
          title: 'Existing Quotes',
          type: 'item',
          url: '/etrack/existing-quotes',
          breadcrumbs: false,
          featureName: 'eTrack',
        },
        {
          id: 'quote-approval',
          title: 'Quote Approval',
          type: 'item',
          url: '/etrack/quote-approval',
          breadcrumbs: false,
          featureName: 'eTrack',
        },
      ],
    },
  ],
};

export default eTrack;
